import React from 'react';

import MiceIcon_1 from 'components/Icons/Mice/MiceIcon-1';
import MiceIcon_3 from 'components/Icons/Mice/MiceIcon-3';

import '../BattaryCell/BattaryCell.scss';

interface MiceAmountCellProps {
  miceAmount: number;
  title?: string;
}

const MiceAmountCell: React.FC<MiceAmountCellProps> = ({ miceAmount, title }) => {
  const bgColor = (() => {
    switch (true) {
      case miceAmount === 0:
        return 'bg-success-custom';
      case miceAmount >= 1:
        return 'bg-danger';
    }
  })();

  const Icon = (() => {
    switch (true) {
      case miceAmount === 0:
        // @ts-ignore
        return <MiceIcon_1 />; // eslint-disable-line react/jsx-pascal-case
      case miceAmount >= 1:
        return <MiceIcon_3 />; // eslint-disable-line react/jsx-pascal-case
    }
  })();

  return (
    <div title={title} style={{ width: '15px' }}>
      <span
        className={`position-absolute mx-4 my-1 top-0 badge rounded-pill ${bgColor}`}
        style={{ marginRight: '10px' }}
      >
        {miceAmount}
      </span>
      {Icon}
    </div>
  );
};

export default MiceAmountCell;
